/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding, ContentChild } from '@angular/core';
import { ButtonGroup } from '../button/button.group';
import { Button } from '../button/button';
import { Menu } from '../menu/menu';

export type DropdownPlacement = 'topLeft' | 'topCenter' | 'topRight' | 'bottomLeft' | 'bottomCenter' | 'bottomRight';
/**
 * Dropdown Button
 */
export class DropdownButton extends ButtonGroup {

     dropdownPrefixCls = 'ant-dropdown-button';
/**
 * 菜单弹出位置：`bottomLeft` `bottomCenter` `bottomRight` `topLeft` `topCenter` `topRight`
 */
placement: DropdownPlacement = 'bottomRight';
/**
 * 按钮组中的第一个按钮
 */
button: Button;
/**
 * 菜单
 */
menu: Menu;
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {
        super(renderer, elementRef);
    }
/**
 * The underlying host native element
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this.elementRef.nativeElement as HTMLElement));
    }
/**
 * 最终样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classnames = super.getClassNames();
        return `${classnames} ${this.dropdownPrefixCls}`;
    }
/**
 * @return {?}
 */
get buttonType(): string {
        return (this.button && this.button.type) || 'default';
    }
/**
 * @return {?}
 */
get disabled(): boolean {
        return (this.button && this.button.disabled) || false;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-dropdown-button',
    template: `
        <ng-content></ng-content>
        <ant-button dropdown [type]="buttonType" [disabled]="disabled" [dropdownPlacement]="placement">
            <ant-icon type="down"></ant-icon>
            <ng-content select="ant-menu"></ng-content>
        </ant-button>
    `,
    styleUrls: [
        './style/index.scss',
        '../button/style/button.group.scss'
    ],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dropdownPrefixCls': [{ type: Input },],
'placement': [{ type: Input },],
'button': [{ type: ContentChild, args: [Button, ] },],
'menu': [{ type: ContentChild, args: [Menu, ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function DropdownButton_tsickle_Closure_declarations() {
/** @type {?} */
DropdownButton.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownButton.ctorParameters;
/** @type {?} */
DropdownButton.propDecorators;
/** @type {?} */
DropdownButton.prototype.dropdownPrefixCls;
/**
 * 菜单弹出位置：`bottomLeft` `bottomCenter` `bottomRight` `topLeft` `topCenter` `topRight`
 * @type {?}
 */
DropdownButton.prototype.placement;
/**
 * 按钮组中的第一个按钮
 * @type {?}
 */
DropdownButton.prototype.button;
/**
 * 菜单
 * @type {?}
 */
DropdownButton.prototype.menu;
/** @type {?} */
DropdownButton.prototype.renderer;
/** @type {?} */
DropdownButton.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
